<div class="w-full flex gap-2 items-center">
  <mat-form-field appearance="outline" class="flex-1">
    <mat-select
      [(ngModel)]="ngModel"
      (selectionChange)="change()"
      [disabled]="bLoad || disabled"
      ngDefaultControl
    >
      <mat-option>
        <ngx-mat-select-search
          ngModel
          (ngModelChange)="search($event, elements, filteredElements);"
          placeholderLabel="Rechercher..."
          noEntriesFoundLabel="Aucun résultat trouvé"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option
        *ngFor="let e of filteredElements | async"
        [value]="e.civilite_ID"
      >
        {{e.civilite_Code}} - {{e.civilite_Libelle}}
      </mat-option>
    </mat-select>
    <mat-spinner
      *ngIf="bLoad"
      matPrefix
      color="primary"
      diameter="20"
      class="ml-2"
    ></mat-spinner>
  </mat-form-field>
  <button
    *ngIf="enableCreate"
    mat-icon-button
    (click)="open(0)"
    matTooltip="Créer nouveau"
  >
    <mat-icon>add</mat-icon>
  </button>
  <button
    *ngIf="enableEdit && ngModel != 0"
    mat-icon-button
    (click)="open(ngModel)"
    matTooltip="Modifier"
  >
    <mat-icon>edit</mat-icon>
  </button>
</div>
